import { useEffect, useRef, useState } from "react";
import {
	articleMove,
	getContentMenu,
	moveRecToParent,
	updateArticleTitle,
} from "./CommonFunc";

function Menu(props) {
	const [filtredContent, setFiltredContent] = useState(props.content);
	const [parentsChain, setParentsChain] = useState([]);
	const [parentLinkMode, setParentLinkMode] = useState({
		stepOne: "",
		stepOneId: undefined,
		stepTwo: "",
		stepTwoId: undefined,
		readyToAction: false,
	});
	const inputRef = useRef();
	const selectedRef = useRef();
	useEffect(() => {
		let arr = [...props.content];
		if (props.visialiseNodePath) {
			arr = arr.slice(
				0,
				arr.findIndex((i) => i.ID === props.currentContentId) + 1
			);
		}
		setFiltredContent(arr);
	}, [props.content, props.currentContentId]);
	const currentSelectedItem = props.content.find(
		(item) => item.ID === props.currentEditableContentId
	);
	useEffect(() => {
		let arr = [...props.content];
		let res = arr.reduce(
			(accum, e, i) => {
				let tempArr = [...accum];
				if (tempArr.findIndex((elem) => elem === e.ID_PAR) !== -1) {
					tempArr.push(e.ID);
				}
				return tempArr;
			},
			[parentLinkMode.stepOneId]
		);
		setParentsChain(res);
	}, [parentLinkMode.stepOneId]);
	useEffect(() => {
		console.log("parentsChain ", parentsChain);
	}, [parentsChain]);
	const refresh = () =>
		getContentMenu().then((content) => {
			props.setContentMenu(content);
		});
	const move = (curs) => {
		articleMove(props.currentEditableContentId, curs).then(refresh);
		if (selectedRef.current) {
			selectedRef.current.scrollIntoView({
				behavior: "smooth",
				block: "center",
				// inline: "nearest",
			});
		}
	};
	const saveTitle = () => {
		updateArticleTitle(
			currentSelectedItem.ID,
			currentSelectedItem.ID_PAR,
			inputRef.current.value
		).then(refresh);
	};
	const randomColor = () =>
		"#" + Math.floor(Math.random() * 16777215).toString(16);
	useEffect(() => {
		if (parentLinkMode.readyToAction === true) {
			moveRecToParent(parentLinkMode.stepOneId, parentLinkMode.stepTwoId).then(
				(res) => {
					refresh();
					setParentLinkMode({
						stepOne: "",
						stepOneId: undefined,
						stepTwo: "",
						stepTwoId: undefined,
						readyToAction: false,
					});
				}
			);
		}
	}, [parentLinkMode.readyToAction]);
	useEffect(() => {
		if (props.isAdmin === false) {
			setParentLinkMode({
				stepOne: "",
				stepOneId: undefined,
				stepTwo: "",
				stepTwoId: undefined,
				readyToAction: false,
			});
		}
	}, [props.isAdmin]);
	return (
		<>
			<div className='menu-wrapper'>
				<ul>
					{filtredContent.map(
						(item) =>
							console.log(item) ?? (
								<li
									key={item.ID}
									onClick={() => {
										if (parentLinkMode.stepOne === "inProgress") {
											setParentLinkMode((prev) => ({
												stepOne: "done",
												stepOneId: item.ID,
												stepTwo: "inProgress",
												stepTwoId: undefined,
												readyToAction: false,
											}));
										} else if (parentLinkMode.stepTwo === "inProgress") {
											setParentLinkMode((prev) => ({
												stepOne: "done",
												stepOneId: prev.stepOneId,
												stepTwo: "done",
												stepTwoId: item.ID,
												readyToAction: true,
											}));
										} else if (props.setCurrentEditableContentId) {
											props.setCurrentEditableContentId(item.ID);
										} else {
											props.goToArticle(item.ID);
										}
									}}
									style={
										parentLinkMode &&
										parentsChain.findIndex((e) => e === item.ID) !== -1
											? { pointerEvents: "none" }
											: {}
									}
								>
									{new Array(item.NUM_LEVEL).fill(1).map((e, i) => (
										<span
											className='tree-block'
											// style={{ backgroundColor: randomColor(), opacity: 0.3 }}
										></span>
									))}
									{props.currentEditableContentId ? (
										<MenuItemEditable
											header={item.HEADER}
											hasChild={item.HAS_CHILD}
											level={item.NUM_LEVEL}
											id={item.ID}
											parentId={item.ID_PAR}
											mapMode={props.mapMode}
											activeEditable={
												props.currentEditableContentId === item.ID
											}
											setContentMenu={props.setContentMenu}
											setParentsChain={setParentsChain}
											parentsChain={parentsChain}
											selectedRef={selectedRef}
											parentLinkMode={parentLinkMode}
										/>
									) : (
										<MenuItem
											active={props.currentContentId === item.ID}
											header={item.HEADER}
											hasChild={item.HAS_CHILD}
											level={item.NUM_LEVEL}
											id={item.ID}
											parentId={item.ID_PAR}
											mapMode={props.mapMode}
											activeEditable={
												props.currentEditableContentId === item.ID
											}
											parentsChain={parentsChain}
											parentLinkMode={parentLinkMode}
										/>
									)}
								</li>
							)
					)}
					<hr></hr>
				</ul>
				{props.isAdmin ? (
					<div className='controls-block'>
						{/* <div>Выделенная вершина:</div> */}
						<div
							style={
								parentLinkMode.stepOne.length > 0 ||
								props.currentEditableContentId < 0
									? {
											opacity: 0.5,
											pointerEvents: "none",
											display: "flex",
											flexDirection: "column",
											gap: "5px",
									  }
									: { display: "flex", flexDirection: "column", gap: "5px" }
							}
						>
							<div className='rename-block'>
								<input
									defaultValue={currentSelectedItem?.HEADER}
									ref={inputRef}
								/>
								<div className='button-action action' onClick={saveTitle}>
									Переименовать
								</div>
							</div>
							<div className='button-action action' onClick={() => move(-1)}>
								Переместить вверх
							</div>
							<div className='button-action action' onClick={() => move(1)}>
								Переместить вниз
							</div>
						</div>
						<div
							className='button-action action'
							style={{ marginTop: 20 }}
							onClick={() => {
								if (parentLinkMode.stepOne.length === 0) {
									props.setCurrentEditableContentId(undefined);
									setParentLinkMode({
										stepOne: "inProgress",
										stepTwo: "",
										result: false,
									});
								} else {
									setParentLinkMode({
										stepOne: "",
										stepOneId: undefined,
										stepTwo: "",
										stepTwoId: undefined,
										readyToAction: false,
									});
								}
							}}
						>
							{parentLinkMode.stepOne.length > 0 ? "Выключить" : "Включить"}{" "}
							режим переноса в другого родителя
						</div>
						<div>
							{parentLinkMode.stepOne ? (
								<>
									<p>
										{parentLinkMode.stepOne === "done" ? <span>✓</span> : null}
										Выберите желаемый узел для переноса в списке слева
									</p>
								</>
							) : null}
							{parentLinkMode.stepTwo ? (
								<>
									<p>
										{parentLinkMode.stepTwo === "done" ? <span>✓</span> : null}
										Выберите родителя к которому будет привязан желаемый узел
										(Для исключения циклических ссылок желаемый узел и его
										дочернии заблокированы для выбора)
									</p>
								</>
							) : null}
						</div>
					</div>
				) : null}
			</div>
		</>
	);
}

function MenuItem({
	header,
	active,
	mapMode,
	activeEditable,
	parentsChain,
	id,
	parentLinkMode,
}) {
	const marked = parentsChain.findIndex((e) => e === id) !== -1;
	return (
		<div
			className={`list-item ${
				(active && !mapMode) || activeEditable ? "active" : ""
			} ${marked && parentLinkMode.stepOne.length > 0 ? "tree-branch" : ""}`}
		>
			{header}
		</div>
	);
}

function MenuItemEditable({
	header,
	id,
	activeEditable,
	parentsChain,
	selectedRef,
	parentLinkMode,
}) {
	const marked = parentsChain.findIndex((e) => e === id) !== -1;
	return activeEditable ? (
		<div
			ref={selectedRef}
			className={`menu-item-editable ${activeEditable ? "active" : ""}`}
		>
			<div>{header}</div>
		</div>
	) : (
		<div
			className={`list-item ${
				marked && parentLinkMode.stepOne.length > 0 ? "tree-branch" : ""
			}`}
		>
			{header}
		</div>
	);
}

export default Menu;
